import { HeadLogo } from "../components/headLogo";
import { GameIntroHeader } from "../components/gameIntroHeader";
import { LocationImageDisplay } from "../components/locationImageDisplay";
import { ProgressHeaderWithPopup} from "../components/progressHeaderWithPopup"

function QuestCompleteView({
  questDisplayName,
  onContinue,
  onModeSelect,
  locationName,
  imageKey,
  mode,
}) {
  return (
    <div >
      <HeadLogo />
      <ProgressHeaderWithPopup currentStep={4} title={locationName} />
      <div className="global-screen-content">
        <GameIntroHeader
          title="Quest Complete"
          description={`You've mastered the ${questDisplayName} challenge! Your journey through time and space continues...`}
        />

        <div className="quest-complete-content">
          <div className="quest-complete-icon">✓</div>
          <div className="quest-complete-title">
            {questDisplayName} Completed!
          </div>
          <div className="quest-complete-buttons">
            <button
              className="quest-complete-checkmore-btn"
              onClick={onModeSelect}
            >
              Start Another Quest
            </button>
            <button
              className="quest-complete-checkmore-btn redo"
              onClick={onContinue}
            >
              {mode === "time" ? "Travel Through Time" : "Explore Global Twin"}
            </button>
          </div>
        </div>
      </div>
      <LocationImageDisplay imageKey={imageKey} />
    </div>
  );
}

export { QuestCompleteView };
